// Port of webapp/src/pages/errorPage.tsx — a message id from the query string
// maps to a localized line. The clone ships Chinese only (no react-intl).

import {ReactElement} from 'react'
import {Link, useSearchParams} from 'react-router-dom'

const messages: Record<string, {title: string, detail: string}> = {
    'not-logged-in': {
        title: '请先登录',
        detail: '该看板需要登录会话，请使用演示账号登录后继续。',
    },
    'not-found': {
        title: '页面不存在',
        detail: '你访问的看板或卡片不在演示数据中。',
    },
    'board-not-found': {
        title: '看板不存在',
        detail: '它可能已被删除，请在左侧侧边栏另选一个看板。',
    },
    'invalid-credentials': {
        title: '账号或密码错误',
        detail: '请使用演示账号「张伟 / 演示」登录，或在设置菜单里重置演示数据。',
    },
}

export default function ErrorPage(): ReactElement {
    const [params] = useSearchParams()
    const id = params.get('id') || 'not-found'
    const redirect = params.get('r')
    const entry = messages[id] || {title: '出错了', detail: `错误标识：${id}`}

    return (
        <div className='flex h-full items-center justify-center px-4'>
            <div className='max-w-[460px] text-center'>
                <div className='mb-3 text-4xl' aria-hidden={true}>⚠️</div>
                <h1 className='mb-2 text-xl font-bold'>{entry.title}</h1>
                <p className='mb-5 text-sm opacity-70'>{entry.detail}</p>
                <div className='flex justify-center gap-2'>
                    <Link to='/login' className='Button Button--primary'>登录</Link>
                    {redirect && (
                        <a href={redirect} className='Button Button--text'>返回</a>
                    )}
                </div>
            </div>
        </div>
    )
}
